import Constants from '../../utils/constants';
export default class ActionCreateRequest {
    constructor(supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: '<span></span>',
                verificationInstruction: '<span></span>',
            };
        });

        this.coinsToEarn = null;
        this.verificationCoinsToEarn = null;
        this.activeFrom = null;
        this.availabilityInStatistics = null;
        this.activeTo = null;
        this.verificationMaxDate = null;
        this.latitude = Constants.initialLatitude;
        this.longitude = Constants.initialLongitude;
        this.localizationTolerance = null;
        this.actionType = null;
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.title = from.title;
        } else {
            to = new ActionCreateRequest();
        }
    }

    static copy(from) {
        const to = new ActionCreateRequest();
        ActionCreateRequest.assign(from, to);
        return to;
    }
}
